// extracted by mini-css-extract-plugin
export default {"spinWrapper":"HistoryChart_spinWrapper__ojtcS"};